import { useEffect, useLayoutEffect, useState } from 'react';
import './App.css';
import Home from './views/home/home';
import Load from './views/load/load';
import emitter, { EVENT_NAME_ONLOAD } from './utils/mitt';
import FPSStats from 'react-fps-stats';

function App() {
  const [showLoad, setShowLoad] = useState(true);
  const [showHome, setShowHome] = useState(true);
  const onLoad = () => {
    setShowLoad(false);
    emitter.emit(EVENT_NAME_ONLOAD);
  };
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowHome(true);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (width < 768) {
        window.location.href = process.env.REACT_APP_API_URL + 'brand/'
      }
    };
    checkDevice();

    window.addEventListener('resize', checkDevice);
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  useLayoutEffect(() => {
    const config = {
      appId: '7b422ab9aeb44285bc0edc3d48b5d305',
      serverUrl: 'https://uas.cmge.com/sync_js',
      autoTrack: {
        pageShow: true, //开启页面展示事件，事件名ta_page_show
        pageHide: true, //开启页面隐藏事件，事件名ta_page_hide
      },
      showLog: false,
    };
    // @ts-ignore
    thinkingdata?.init(config);
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.ta = thinkingdata;
    }
  });


  // useLayoutEffect(() => {
  //   // 重载页面前提交报告
  //   const onPageShow = () => {
  //     console.log("onPageShow")
  //     reportEvent('brand_page_view', {
  //       page_state: '进入',
  //       button_type: STATE_NAME[0],
  //       browsing_time: '',
  //     });
  //     const current = new Date().getTime();
  //     setBrowserTime(current);
  //   }
  //   window.addEventListener("pageshow", onPageShow)
  //   return () => {
  //     window.removeEventListener("pageshow", onPageShow)
  //   }
  // }, [])
  // useLayoutEffect(() => {
  //   let hasHandled = false; // 标志变量

  return (
    <div className="app_wrapper fullscreen">
      {showHome && <Home />}
      {showLoad && <Load onLoad={onLoad} />}
      {process.env.NODE_ENV === 'development' && <FPSStats />}
    </div>
  );
}

export default App;
